export { AtnDsPageHeaderBreadcrumbsComponent as Component } from './page-header-breadcrumbs.component'
